import {Datagrid, ListProps, TextField, TextInput} from "react-admin";
import {CustomList} from "../components/CustomList";
import {IdentifierField} from "../components/IdentifierField";
import {initField} from "../shared/utils";
import {useOptionsResource} from "../shared/hooks/useOptionsResource";


export const TagList = (props: ListProps) => {
    const {data: options} = useOptionsResource("GET");

    const filters = options ? [
        <TextInput {...initField("name", options)} alwaysOn label="Nome" />,
    ] : []

    return options ? (
        <CustomList {...props} filters={filters}>
            <Datagrid>
                <IdentifierField {...initField("id", options)} />
                <TextField {...initField("name", options)} />
                <TextField {...initField("description", options)} />
            </Datagrid>
        </CustomList>
    ) : null;
}